import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'licenseFilter'
})
export class LicenseFilterPipe implements PipeTransform {

  transform(value: any, association: string): any {
    let licenses = [...value];
    licenses = licenses.filter(license => license.Association == association)
    return licenses;
  }

}
